import React, { useState, useEffect,useRef } from 'react';
import {Main,Axios,uuidv4,usePaginacion,Paginacion} from '../../../Helpers/importacionesComunes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {formatearComparacion,hacerfocoEnPrimerInput} from '../../../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../../../Helpers/fechas';
import { Button, Card, Checkbox, Input, Spinner, Typography, Switch } from '@material-tailwind/react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Tabla } from '../componentes/Tabla';
import { TablaMobile } from '../componentes/TablaMobile';
import { useHistory, useLocation } from "react-router-dom";
import { TrashIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/outline';
import { SearchResultsCounter } from '../../ComponentesComunes/SearchResultsCounter';

import Swal from 'sweetalert2';
import { set } from 'date-fns';

const anchoPaginacion = 50;
const distr = ['tipo-r-rd', 'tipo-r-fd']
const res = ['tipo-r-geo']

const OPCIONES_COLUMNAS_OCULTAR = [
    { key:'fondo', label:'Fondo' },
    { key:'titulo', label:'Título' },
    { key:'formapago', label:'Forma de Pago' },
    { key: 'subtotal', label: 'Subtotal' }
];

const initParams = {
    id_tanda:103,
    tipo: 'tipo-rg',
    id_año_fiscal:null,
    mesAño:null,
    año:null,
    id_obrero: null,
    criterio:'fecha',
    destino: 'pastor',
    nombre_destino:'',
    id_obrero:null,
    isexterno: false,
    id_iglesia:null,
    id_proveedor:null,    
    id_provincia: null,  
    id_region: null,
    id_fondo_tesoreria: null,
    usuario_alta: null,   
    tipo_recibo: null,                                       
    formapago:null,
    rubro:null,
    fondo:null,
    moneda:1,
    caja:null,
    fechaDesde:new Date(obtenerFechaDiamenosN(365,'DD/MM/YYYY').diamenosn),
    fechaHasta:new Date(),
    fecha:new Date(),
    descripcionCriterio:'',
    total_caja:false,
    total_diario:false,
    total_mensual:false,
    fdo_regiones: false,
    hiddenCols: [],
    total_año:false,
    nro_desde: null,
    nro_hasta: null,
    orden: null,
    no_agrupar:false,
}


const INGRESOS_T_SEARCH_STATE_KEY = 'ingresos-t-search-state';
const INGRESOS_T_DATE_FIELDS = ['mesAño', 'año', 'fechaDesde', 'fechaHasta', 'fecha'];

// Tope de registros que persistimos para poder restaurar la búsqueda al volver del detalle.
// JSON.stringify es sincrónico: con miles de registros bloquea la UI y además supera
// la cuota de sessionStorage. Por encima del tope no se persiste (la búsqueda igual funciona).
const INGRESOS_T_MAX_REGISTROS_PERSISTIDOS = 2000;

const guardarEstadoBusquedaIngresosT = (state) => {
    try {
        if ((state?.datos?.length ?? 0) > INGRESOS_T_MAX_REGISTROS_PERSISTIDOS) {
            sessionStorage.removeItem(INGRESOS_T_SEARCH_STATE_KEY)
            return
        }
        sessionStorage.setItem(INGRESOS_T_SEARCH_STATE_KEY, JSON.stringify(state))
    } catch (error) {
        console.log('No se pudo guardar el estado de búsqueda de ingresos', error)
    }
}

const leerEstadoBusquedaIngresosT = () => {
    const savedState = sessionStorage.getItem(INGRESOS_T_SEARCH_STATE_KEY)

    if (!savedState) {
        return null
    }

    try {
        const parsedState = JSON.parse(savedState)
        const parametrosRestaurados = { ...parsedState?.parametros }

        INGRESOS_T_DATE_FIELDS.forEach((field) => {
            if (parametrosRestaurados?.[field]) {
                parametrosRestaurados[field] = new Date(parametrosRestaurados[field])
            }
        })

        return {
            parametros: parametrosRestaurados,
            datos: Array.isArray(parsedState?.datos) ? parsedState.datos : [],
        }
    } catch (error) {
        console.log('No se pudo restaurar el estado de búsqueda de ingresos', error)
        return null
    }
}

export default function IngresosTesoreria({usuario}){
    const history = useHistory();
    const location = useLocation();
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const {esCelular} = useContextoGlobal();
    const [contadorConsulta,setContadorConsulta]=useState(0);
    const [mostrarDist, setMostrarDist] = useState(false);  
    const [parametros,setParametros]=useState(initParams)
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [provincias,setProvincias] = useState([]);
    const [regiones,setRegiones] = useState([]);
    const [obreros,setObreros] = useState([]);
    const [backUpObreros,setBackUpObreros] = useState([]);
    const [terminalesUsers,setTerminalesUsers] = useState([]);
    const [tipoRecibos,setTipoRecibos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const [IsFetchingData, setIsFetchingData] = useState(false);
    const [hideFormvalues,setHideFormvalues] = useState({})
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
        .then(()=>{
         console.log(tandas)
            // setParametros({...parametros,id_tanda:tandas[0].id_tanda})
        })
    },[])

    // Al volver desde el detalle/envío de recibo (con restoreSearch) recuperamos la búsqueda previa
    useEffect(() => {
        if (!location.state?.restoreSearch) {
            return
        }

        const estadoGuardado = leerEstadoBusquedaIngresosT()

        if (estadoGuardado) {
            setParametros(estadoGuardado.parametros)
            setDatos(estadoGuardado.datos)
        }

        history.replace({ pathname: location.pathname, state: undefined })
    }, [history, location.pathname, location.state])

    useEffect(()=>{
        setReporteEnEjecucion(false)
        if (distr.includes(parametros?.tipo)) setMostrarDist(true); 
        else setMostrarDist(false);
    },[parametros])

    useEffect(()=>{
        if(tandas.length>0){
            setParametros({...parametros,id_tanda:tandas[0].id_tanda})
        }
    },[tandas])

    useEffect(() => {
        const actualizarCamposOcultos = () => {
            const camposOcultos = {};
    
            switch (parametros?.tipo) {
                case 'tipo-r-ru':
                case 'tipo-r-fd':
                case 'tipo-r-geoplano':
                case 'tipo-r-geopa':
                    camposOcultos.orden = true;
                    break;
    
                case 'tipo-r-rd':
                    camposOcultos.rubro = false; 
                    break;
    
                case 'tipo-r-fd':
                    camposOcultos.rubro = false;
                    break;
    
                case 'tipo-r-geo':
                    camposOcultos.rubro = false;
                    camposOcultos.caja = false; 
                    camposOcultos.fondo = false; 
                    camposOcultos.formapago = false;
                    camposOcultos.orden = true;
                    break;
    
                default:
                    // Mostrar todos los campos si no coincide con ningún tipo
                    break;
            }
    
            setHideFormvalues(camposOcultos);
        };
    
        actualizarCamposOcultos();
    }, [parametros?.tipo]);
    
    useEffect(()=>{
        if(!parametros.destino){
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_iglesia:null,id_proveedor:null})
        }else if(parametros.destino=='pastor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }else if(parametros.destino=='proveedor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_obrero:null})
            hacerfocoEnPrimerInput('destino-n')
        }else{
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }
    },[parametros.destino])

    useEffect(()=>{
        subtitulo.current = crearSubtitulosSegunParametros()
    },[parametros,cargandoRegistros]) // agrego a las dependencias la variable cargandoRegistros para que cree el subtitulo inmediatamente aunque no hayan cambiado los parametros porque podría ejecutar el reporte sin modificar la selección o sea con los valores iniciales

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get(usuario?.perfil === 'region' ? `/api/tablasgenerales/rubrosingresos/region/${usuario?.id_region  || 0 }` : '/api/tablasgenerales/rubrosingresos'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/reportes/tablas/cajas'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/reportes/tablas/formaspago'),
            Axios.get(usuario?.perfil === 'region' ? `/api/tablasgenerales/provincias/region/${usuario?.id_region  || 0 }` : '/api/tablasgenerales/provincias'),
            Axios.get('/api/tablasgenerales/terminales-usuarios'),
            Axios.get('/api/tablasgenerales/tipo-recibos'),
            Axios.get('/api/tablasgenerales/regiones'),
            Axios.get('/api/tablasgenerales/obreros')])
            setTandas(vectorResultados[0].data)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setFormasPago(vectorResultados[6].data)
            setProvincias(vectorResultados[7].data)
            setTerminalesUsers(vectorResultados[8].data)
            setTipoRecibos(vectorResultados[9].data)
            setRegiones(vectorResultados[10].data)
//            setObreros(vectorResultados[11].data)
            setObreros(vectorResultados[11].data.filter(o=>o?.externo==false)) // ps 14/08/2026 por default se muestran los ministros uad internos
            setBackUpObreros(vectorResultados[11].data)
            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const ejecutarBusqueda = async ()=>{
        try{
            setIsFetchingData(true);
            const url = '/api/tablasgenerales/ingresosv2/lista';

            // N° de comprobante: si se completa un solo extremo se busca ESE comprobante.
            // Antes, dejar "hasta" vacío abría el rango hasta el infinito y traía todos los
            // comprobantes desde ese número en adelante (búsqueda enorme que colgaba la pantalla).
            const aNroComprobante = (valor) => {
                const texto = String(valor ?? '').trim()
                if (texto === '') return null
                const numero = Number(texto)
                // 0 se considera "sin valor" (no existe comprobante 0) para no invertir el rango
                return Number.isNaN(numero) || numero <= 0 ? null : numero
            }
            const nroDesde = aNroComprobante(parametros.nro_desde)
            const nroHasta = aNroComprobante(parametros.nro_hasta)

            let dataSubmit = {
                mes: parametros.criterio === 'mesaño' ? parametros.mesAño.getMonth() + 1 : null,
                año: parametros.criterio === 'año' ? parametros.año.getFullYear() : parametros.criterio === 'mesaño' ? parametros.mesAño.getFullYear() : null,
                id_año_fiscal: parametros.id_año_fiscal ? Number(parametros.id_año_fiscal) : null,
                f_desde: parametros.criterio === 'periodo' ? convertirMesAñoAfechaDesde(parametros.fechaDesde) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fecha) :  null,
                f_hasta: parametros.criterio === 'periodo' ? convertirMesAñoAfechaHasta(parametros.fechaHasta) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fecha) : null,
                id_rubro: parametros.rubro ? Number(parametros.rubro) : null,
                id_forma_pago: parametros.formapago ? Number(parametros.formapago) : null,
                nro_desde: nroDesde ?? nroHasta,
                nro_hasta: nroHasta ?? nroDesde,
                id_obrero: parametros.id_obrero ? Number(parametros.id_obrero) : null,
                id_iglesia: parametros.id_iglesia ? Number(parametros.id_iglesia) : null,
                id_provinciaP: parametros.id_provincia ? Number(parametros.id_provincia) : null,
                id_region: parametros.id_region ? Number(parametros.id_region) : null,
                usuario: parametros.usuario_alta,
                tipo_compr: parametros.tipo_recibo === "*" ? null : parametros.tipo_recibo,
                id_fondo_tesoreria: parametros.id_fondo_tesoreria ? Number(parametros.id_fondo_tesoreria) : null,
                fdo_regiones: parametros.fdo_regiones === false ? null : true,
                // externo: obreros.find(o => o.id_obrero === Number(parametros.id_obrero))?.externo, // ps 14/08/2026 si no hay un ministro seleccionado se usa el checkbox para filtrar por movimientos externos
                externo: parametros.isexterno===null ? null : parametros.id_obrero ? obreros.find(o => o.id_obrero === Number(parametros.id_obrero))?.externo : parametros.isexterno ? true: false, // 
            };
            
            console.log(dataSubmit);
            const dataBusqueda = await Axios.post(url, dataSubmit);
            
            if (dataBusqueda.data.length === 0) Swal.fire(`No se ha encontrado ningún registro`,'','info')
            console.log(dataBusqueda)
            setDatos(dataBusqueda.data);
            // Persistimos la búsqueda para poder restaurarla al volver desde el detalle/envío de recibo
            guardarEstadoBusquedaIngresosT({ parametros, datos: dataBusqueda.data });
            setIsFetchingData(false);
        } catch(err){
            console.log(err);
            console.log('Error al buscar los datos generales')  
            Swal.fire({
                icon: 'error',
                title: `<p>Ha ocurrido un error durante la petición</p>`,
                showCancelButton: true,
            });
            setIsFetchingData(false)
        }
    }

    const cleanUpData = () => { 
        setDatos([]);
    }

    const deleteIngreso = async (id_egreso) => { 
        Swal.fire({
            text: '¿Está seguro de eliminar este ingreso?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Axios.delete('/api/tablasgenerales/ingresos/borrar', { id_egreso });
                        ejecutarBusqueda();
                        Swal.fire(`Ingreso eliminado con éxito`,'','info') 
                    } catch (error) { 
                        console.log("Error al eliminar el ingreso", error);
                        Swal.fire(`Error al eliminar el ingreso`,'','error')
                    }
                } else console.log("Se canceló la creación de un nuevo ingreso")
            }
        )
    }

    const crearSubtitulosSegunParametros = ()=>{
        let descripcion = '';

        switch (parametros.criterio) {
            // case 'tanda':
            //     descripcion = `${descripcion} Tanda: ${tandas.filter(item => item.id_tanda == parametros.id_tanda).map(item => item.nombre)}`;
            //     break;
            case 'añofiscal':
                descripcion = `${descripcion} Año fiscal: ${periodosFiscales.filter(item => item.id_año_fiscal == parametros.id_año_fiscal).map(item => item.nombre)}`;
                break;
            case 'mesaño':
                descripcion = `${descripcion} Mes y año: ${document.getElementById('select-mesaño')?.value || 'N/A'}`;
                break;
            case 'año':
                descripcion = `${descripcion} Año: ${document.getElementById('select-año')?.value || 'N/A'}`;
                break;
            case 'periodo':
                const desde = document.getElementById('select-periodo-fdesde')?.value || 'N/A';
                const hasta = document.getElementById('select-periodo-fhasta')?.value || 'N/A';
                descripcion = `${descripcion} Período: ${desde} --> ${hasta}`;
                break;
            case 'fecha':
                descripcion = `${descripcion} Fecha: ${document.getElementById('select-fecha')?.value || 'N/A'}`;
                break;
        }
        return descripcion
    }

    const cb_filtro = item=>
    formatearComparacion(item.codigo_rubro).includes(formatearComparacion(textoBusqueda)) ||
    formatearComparacion(item.rubro).includes(formatearComparacion(textoBusqueda))

    const generarTituloPDF = () => {
        const partes = [];
        
        // ➤ Criterio de búsqueda
        switch (parametros.criterio) {
          case 'fecha':
            partes.push(`Fecha: ${formatearFechaCorta(parametros.fecha)}`);
            break;
          case 'mesaño':
            if (parametros.mesAño) {
              partes.push(`Mes/Año: ${formatearMesAño(parametros.mesAño)}`);
            }
            break;
          case 'año':
            if (parametros.año) {
              partes.push(`Año: ${parametros.año.getFullYear()}`);
            }
            break;
          case 'periodo':
            partes.push(`Período: ${formatearFechaCorta(parametros.fechaDesde)} -> ${formatearFechaCorta(parametros.fechaHasta)}`);
            break;
          case 'añofiscal':
            const periodo = periodosFiscales.find(p => p.id_año_fiscal === parametros.id_año_fiscal);
            if (periodo) {
              partes.push(`Año Fiscal: ${periodo.descripcion}`);
            }
            break;
        }
      
        // ➤ Rubro
        if (parametros.rubro) {
          const rubro = rubros.find(r => Number(r.id_rubro_ingreso) === Number(parametros.rubro));
          if (rubro) partes.push(`• Rubro: ${rubro.nombre}`);
        }
      
        // ➤ Forma de Pago
        if (parametros.formapago) {
          const fp = formasPago.find(f => Number(f.id_forma_pago) === Number(parametros.formapago));
          if (fp) partes.push(`• Forma de pago: ${fp.nombre}`);
        }
      
        // ➤ Obrero
        if (parametros.id_obrero) {
          const obrero = obreros.find(o => Number(o.id_obrero) === Number(parametros.id_obrero));
          if (obrero) partes.push(`• Obrero: ${obrero.nombre}`);
        }
      
        // ➤ Iglesia
        if (parametros.id_iglesia) {
          const iglesia = terminalesUsers.find(i => Number(i.id_iglesia) === Number(parametros.id_iglesia));
          if (iglesia) partes.push(`• Iglesia: ${iglesia.nombre}`);
        }
      
        // ➤ Provincia
        if (parametros.id_provincia) {
          const provincia = provincias.find(p => Number(p.id_provincia) === Number(parametros.id_provincia));
          if (provincia) partes.push(`• Provincia: ${provincia.nombre}`);
        }
      
        // ➤ Región
        if (parametros.id_region) {
          const region = regiones.find(r => Number(r.id_region) === Number(parametros.id_region));
          if (region) partes.push(`• Región: ${region.nombre}`);
        }
      
        // ➤ Tipo de Recibo
        if (parametros.tipo_recibo && parametros.tipo_recibo !== '*') {
          const tipoRecibo = tipoRecibos.find(t => t.tipo_recibo === parametros.tipo_recibo);
          if (tipoRecibo) partes.push(`• Tipo Recibo: ${tipoRecibo.tipo_recibo}`);
        }
      
        return partes.join('   ');
    };

    const formatearFechaCorta = (fecha) => {
        const f = new Date(fecha);
        return f.toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' });
    };
    
    const formatearMesAño = (fecha) => {
        const f = new Date(fecha);
        return f.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
    };
      

    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        <div className={'w-full px-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Ingresos
                </Typography>
            </div>
            <Parametros parametros = {parametros} 
                        setParametros={setParametros} 
                        tandas={tandas}
                        provincias={provincias}
                        regiones={regiones}
                        terminalesUsers={terminalesUsers}
                        tipoRecibos={tipoRecibos}
                        periodosFiscales ={periodosFiscales} 
                        centrado={contadorConsulta==0 ? true : false}
                        cajas = {cajas}
                        rubros = {rubros}
                        monedas = {monedas}
                        fondos = {fondos}
                        usuario = {usuario}
                        formasPago = {formasPago}
                        obreros = {obreros}
                        mostrarDist = {mostrarDist}
                        IsFetchingData = {IsFetchingData}
                        hideFormvalues = {hideFormvalues}
                        backUpObreros={backUpObreros}
                        history = {history}
                        setObreros={setObreros}
                        ejecutarBusqueda={ejecutarBusqueda} />
        </div>

        {datos.length > 0 && <SearchResultsCounter count={datos.length} badgeLabel="Ingresos" />}

        {esCelular && datos.length > 0 && <TablaMobile registrosAmostrar={datos} cleanUpData={cleanUpData} deleteIngreso={deleteIngreso} onCrearIngreso={() => history.push('/ingreso/crear-e')} />}

        {!esCelular && datos.length > 0 && <Tabla
            registrosAmostrar={datos}
            cleanUpData={cleanUpData}
            deleteIngreso={deleteIngreso}
            onCrearIngreso={() => history.push('/ingreso/crear-e')}
        />}
    </Main>
    )
}
function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    provincias,
                    terminalesUsers,
                    tipoRecibos,
                    periodosFiscales,
                    rubros,
                    history,
                    obreros,
                    formasPago,
                    IsFetchingData,
                    ejecutarBusqueda,
                    backUpObreros,
                    setObreros,
                    usuario,
                    setNombreCriterio}){

    const inputBusquedaRef = useRef()
    const nombreCriterio = useRef('Seleccione el año fiscal:')

    const [iglesias,setIglesias] = useState([])
    const { esCelular} = useContextoGlobal();

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        console.log("parametros", parametros);
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales,setNombreCriterio)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckNoAgrupar = (e)=>{
        setParametros({...parametros,no_agrupar : parametros.no_agrupar ? null : e.target.name=="checknoagrupar" ? 1 : e.target.value})
    }

    const handleCheckTotalCaja = (e)=>{
        setParametros({...parametros,total_caja : parametros.total_caja ? false : true})
    }

    const handleCheckTotalDiario = (e)=>{
        setParametros({...parametros,total_diario : parametros.total_diario ? false : true})
    }

    const handleCheckTotalMensual = (e)=>{
        setParametros({...parametros,total_mensual : parametros.total_mensual ? false : true})
    }

    const handleCheckTotalAño = (e)=>{
        setParametros({...parametros,total_año : parametros.total_año ? false : true})
    }

    const validarParametros = ()=>{

        if (parametros.criterio=="tanda" && !parametros.id_tanda){
            alert('Falta seleccionar una tanda')
            return
        }

        if (parametros.criterio=="añofiscal" && !parametros.id_año_fiscal){
            alert('Falta seleccionar un año fiscal')
            return
        }
        if (parametros.criterio=="año" && !parametros.año){
            alert('Falta seleccionar un año')
            return
        }
        if (parametros.criterio=="mesaño" && !parametros.mesAño){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="periodo" && (!parametros.fechaHasta || !parametros.fechaDesde)){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="fecha" && !parametros.fecha){
            alert('Falta seleccionar un mes y un año')
            return
        }
        ejecutarBusqueda()
    }

   const limpiarFiltros = () => { 
    setParametros(initParams);
   }

    const buscarIglesiasPorObrero = async (e)=>{
        const id_obrero = e.target.value;
        setParametros({...parametros, id_obrero, id_iglesia: null});
        try{
            if (!id_obrero) {
                setIglesias([]);
                return;
            }
            const iglesias = await Axios.get('/api/tablasgenerales/iglesiasobrero/'+id_obrero)
            setIglesias(iglesias.data)
        }catch(err){
            console.log('Error al buscar los datos generales')  
        }
    }

    const handleChangeHiddenCols = (e) => {
        const { value } = e.target;
        setParametros({
          ...parametros,
          hiddenCols: typeof value === 'string' ? value.split(',') : value
        });
    };
    
    return <>
        <Card className="mt-4 w-full p-10 mb-0">
                <div className="flex f-col">
                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className='w-[220px]'>
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Intervalo de Tiempo:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                            <select
                                                label="Seleccionar Intervalo"
                                                value={parametros.criterio}
                                                className='select-bg-ui'
                                                onChange={(val) =>  handleCheckCriterio(val)}
                                            >
                                                <option value="">Sin Fecha</option>
                                                <option value="añofiscal">Año fiscal</option>
                                                <option value="mesaño">Mes/año</option>
                                                <option value="año">Año</option>
                                                <option value="periodo">Periodo</option>
                                                <option value="fecha">Fecha</option>
                                            </select>                                       
                                        </div>   
                                    </div>
                                </div>

                                <div className="flex flex-col w-full">
                                    <div className="relative mt-2 w-full">
                                    {parametros.criterio=="tanda" && <div className="flex f-row w-full ">
                                            <Seleccionador id="select-tanda" vector={tandas} valor={parametros.id_tanda} nombre="Todas" onchange={(e)=>setParametros({...parametros,id_tanda:e.target.value})} claves={{id:'id_tanda',nombre:'nombre'}}/>
                                        </div>}

                                        {parametros.criterio=="añofiscal" && <div className="flex f-row w-full">
                                            <Seleccionador id="select-añofiscal" vector={periodosFiscales} valor={parametros.id_año_fiscal} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_año_fiscal:e.target.value})} claves={{id:'id_año_fiscal',nombre:'nombre'}}/>
                                        </div>}     

                                        {parametros.criterio=="mesaño" && <div className="flex f-row w-full">
                                                    {<DatePicker selected={parametros.mesAño} 
                                                        onChange={date => setParametros({...parametros,mesAño:date})} 
                                                        locale="es"
                                                        dateFormat="MM/yyyy"
                                                        id="select-mesaño"
                                                        className="select-bg-ui !h-9"
                                                        showMonthYearPicker
                                                        showFullMonthYearPicker
                                                        showFourColumnMonthYearPicker
                                                    />}
                                        </div>}

                                        {parametros.criterio=="año" && <div className="flex f-row w-full">
                                                    {<DatePicker selected={parametros.año} 
                                                        onChange={date => setParametros({...parametros,año:date})} 
                                                        locale="es"
                                                        id="select-año"
                                                        className="select-bg-ui !h-9"
                                                        showYearPicker
                                                        dateFormat="yyyy"
                                                    />}
                                        </div>}

                                        {parametros.criterio=="periodo" && <div className="flex f-row w-full">
                                                <div className="flex f-row mt-[-15px]">
                                                            <div className="flex f-col">
                                                                <span className="text-xsmall">Desde</span>
                                                                <DatePicker selected={parametros.fechaDesde} 
                                                                    onChange={date => setParametros({...parametros,fechaDesde:date})} 
                                                                    locale="es"
                                                                    dateFormat="MM/yyyy"
                                                                    id="select-periodo-fdesde"
                                                                    showMonthYearPicker
                                                                    className="select-bg-ui !h-9"
                                                                    showFullMonthYearPicker
                                                                    showFourColumnMonthYearPicker/>
                                                            </div>
                                                            <div className="flex f-col ml-2 w-full">
                                                                <span className="text-xsmall">Hasta</span>
                                                                <DatePicker selected={parametros.fechaHasta} 
                                                                    onChange={date => setParametros({...parametros,fechaHasta:date})} 
                                                                    locale="es"
                                                                    dateFormat="MM/yyyy"
                                                                    id="select-periodo-fhasta"
                                                                    className="select-bg-ui !h-9"
                                                                    showMonthYearPicker
                                                                    showFullMonthYearPicker
                                                                    showFourColumnMonthYearPicker/>
                                                            </div>
                                                </div>
                                        </div>}

                                        {parametros.criterio=="fecha" && <div className="flex f-row w-full">
                                                <div className="flex f-row egreso-list w-full">
                                                        <DatePicker selected={parametros.fecha} 
                                                            id="select-fecha"
                                                            className="select-bg-ui !h-9 w-full"
                                                            onChange={date => setParametros({...parametros,fecha:date})} 
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="es"/>
                                                </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </Card>

                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Ministros:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%] relative">
                                            <select
                                                disabled={parametros.isexterno === null}
                                                title={parametros.isexterno === null ? 'Parámetro deshabilitado por el check "Todos"' : ''}
                                                label="Seleccionar Pastor"
                                                value={parametros.id_obrero}
                                                className={`select-bg-ui w-full ${parametros.isexterno === null ? ' cursor-not-allowed' : ''}`}
                                                onChange={(val) => buscarIglesiasPorObrero(val) }
                                            >
                                                <option value="">Seleccionar</option>
                                                {obreros.map(item => 
                                                    <option value={item.id_obrero} key={item.id_obrero}>{item.nom_simple}</option>)
                                                }
                                            </select>
                                            <TrashIcon 
                                                width={20} 
                                                height={20} 
                                                className='cursor-pointer hover:opacity-85 mt-2 absolute top-0 right-[-25px] z-10' 
                                                onClick={() => setParametros({...parametros, id_iglesia: "", id_obrero: ""})}
                                            />
                                        </div>
                                    </div>
                                </div> 

                                <div className="flex items-center gap-2 w-full mt-3">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Externos:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className={`mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%] ${parametros.isexterno === null ? ' cursor-not-allowed' : ''}`} title={parametros.isexterno === null ? 'Parámetro deshabilitado por el check "Todos"' : ''}>
                                            <Switch
                                                ripple={false}
                                                disabled={parametros.isexterno === null}
                                                name="isexterno"
                                                checked={parametros.isexterno}
                                                onChange={(e) => { 
                                                    console.log(e.target.checked, backUpObreros);
                                                    setParametros({ ...parametros, isexterno: e.target.checked ? true : false })
                                                    if (e.target.checked) { 
                                                        setObreros(
                                                            backUpObreros.filter(o => o?.externo==true)
                                                        )
                                                    } //else setObreros(backUpObreros) // ps 14/08/2026 filtramos estricto por externo true o false 
                                                    else setObreros(backUpObreros.filter(o => o?.externo==false))
                                                }}
                                            />
                                        </div>   
                                    </div>
                                     <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Todos:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]" title='Buscar todos, incluye ingresos internos y externos. Desmarque este parámetro para poder filtrar por ministros.'>
                                            <Switch
                                                ripple={false}
                                                name="origen_todos"
                                                checked={parametros.isexterno===null}
                                                onChange={(e) => { 
                                                    const isChecked = e.target.checked;
                                                    setParametros({ ...parametros, id_iglesia: "", id_obrero: "",  isexterno: e.target.checked ? null : false })
                                                }}
                                            />
                                        </div>   
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Provincia:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Seleccionador  id='select-provincia' vector={provincias} valor={parametros.id_provincia} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_provincia:e.target.value})} claves={{id:'id_provincia',nombre:'nombre'}}/>
                                        </div>   
                                    </div>
                                </div>
                            </div>
                        </Card>

                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Terminales Usuarios:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Seleccionador  id='select-terminales-users' vector={terminalesUsers} valor={parametros.usuario_alta} nombre="Todos" onchange={(e)=>setParametros({...parametros,usuario_alta:e.target.value})} claves={{id:'usuario_alta',nombre:'usuario_alta'}}/>
                                        </div>   
                                    </div>
                                </div>

                                {/* Segunda columna */}
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Fondos:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Seleccionador  
                                                id='select-rubro' 
                                                vector={rubros} 
                                                valor={parametros.rubro} 
                                                nombre="Todos"
                                                noDefault={usuario?.perfil==='region' ? true : false}
                                                disabled={parametros.fdo_regiones} 
                                                onchange={(e)=>setParametros({...parametros,rubro:e.target.value}) } claves={{id:'id_rubro_ingreso',nombre:'nombre'}}
                                            />
                                        </div>   
                                    </div>
                                </div>
        
                                {/* Tercera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Tipo Recibo:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Seleccionador  id='select-fpago' vector={tipoRecibos} valor={parametros.tipo_recibo} nombre="Todos" onchange={(e)=>setParametros({...parametros,tipo_recibo:e.target.value})} claves={{id:'tipo_recibo',nombre:'tipo_recibo'}}/>
                                        </div>
                                    </div>  
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            N° de Comprobante:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="flex gap-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="comprobante-desde"
                                                id="comprobante-desde" 
                                                type="number" 
                                                value={parametros.nro_desde} 
                                                onChange={(e) => setParametros({ ...parametros, nro_desde: e.target.value })} 
                                                ref={inputBusquedaRef} 
                                                placeholder={'0'}
                                                className="input-ui-data w-full"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                            <Input
                                                name="comprobante-hasta"
                                                id="comprobante-hasta" 
                                                type="number" 
                                                value={parametros.nro_hasta} 
                                                onChange={(e) => setParametros({ ...parametros, nro_hasta: e.target.value })} 
                                                ref={inputBusquedaRef} 
                                                placeholder={'0'}
                                                className="input-ui-data w-full"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div>
                                </div>
                                    
                            </div>
                        </Card>

                    {parametros.tipo=='resumen' && <div className={`${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Reporte sin agrupar en meses"
                                ripple={false}
                                name="checknoagrupar" 
                                checked={parametros.no_agrupar}
                                onClick={handleCheckNoAgrupar}
                                className='w-5 h-5'
                                />
                            </div>           
                        </div>
                    }

                    {parametros.tipo=='cronologico' && <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Totales por caja"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_caja}
                                onClick={handleCheckTotalCaja}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales diarios"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_diario}
                                onClick={handleCheckTotalDiario}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales mensuales"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_mensual}
                                onClick={handleCheckTotalMensual}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales por año"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_año}
                                onClick={handleCheckTotalAño}
                                className='w-5 h-5'
                            />
                            </div>           
                        </div>
                       }


                    <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left'}`}>
                        <Typography variant="h5" color="blue-gray" className="mt-1">
                            Reporte:
                        </Typography>
                        <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Resumen"
                                ripple={false}
                                checked={parametros.tipo=='resumen'} 
                                id="tipo-resumen" 
                                name = "tipo" 
                                value="resumen" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Cronológico"
                                ripple={false}
                                checked={parametros.tipo=='cronologico'} 
                                id = "tipo-crono" 
                                name="tipo" 
                                value="cronologico" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                        </div>           
                    </div>

                    <div className='mt-4 flex w-full justify-center pr-4 md:justify-end'>
                        <div className='flex'>
                            <Button 
                                className="h-[40px] w-40 flex items-center justify-center gap-2 bg-[#2FB18F] text-white" 
                                onClick={() => { 
                                    history.push('/ingreso/crear-e') 
                                }}>
                                <PlusIcon className="h-4 w-4" />
                                Añadir
                            </Button>
                        </div>
                    </div>
            </div>
        </Card>
        <div className='mt-3 flex w-full flex-wrap justify-end gap-2 pr-4'>
            <Button
                    color="blue"
                    className="flex justify-center rounded-md h-[40px] w-40"
                    onClick={validarParametros}
                >
                    {IsFetchingData ? 
                        <Spinner className="h-4 w-4 mr-2" /> : 
                        <>
                            <MagnifyingGlassIcon className="h-4 w-4 mr-2" /> Buscar
                        </>
                    }  
            </Button>
            <Button 
                variant='text' 
                className='text-red-400 bg-red-100 hover:bg-red-200 h-[40px] w-40' 
                onClick={limpiarFiltros}>
                    Limpiar Filtros
            </Button>
        </div>
    </>
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    disabled,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select disabled={disabled} value={valor} name={name? name : ''} className='h-9' onChange ={onchange} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]}>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}  

function SeleccionadorReportes({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    vector, 
    claves, 
    limpiar,
    disabled,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select disabled={disabled} value={valor} name={name? name : ''} className='h-9' onChange ={onchange} id={id? id : null}>
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]}>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
} 

function determinarClases(reporteEnEjecucion){
    return reporteEnEjecucion ? "items-center justify-center ml-auto mr-auto" : "flex f-col items-center justify-center ml-auto mr-auto"
}

function objetosSegunParametros(parametros,objeto){

    if (parametros.tipo=='cronologico'){
        switch(objeto){
            case 'api': return `api/reportes/reporteegresos/${masParametros(parametros)}`
            case 'titulo': return 'Egresos cronológicos'
            case 'titulos': return {col1:'Fecha',col2:'Proveedor',col3:'Comprobante',col4:'Descripcion',col5:'Monto'}
            case 'columnas' : return {col1:'Manejo las columnas en la funcion bodyTablaEgresosCronologicos'}
            case 'filtro' : return {campo1:'proveedor',campo2:'descripcion', campo3:'rubro', campo4:'caja',campo5:'fondo',campo6:'datos_bcrios',campo7:'monto_numerico'}
            case 'csv' : return item=>{return {fecha:transformarIso8601(item.fecha),proveedor:item.proveedor,tipo_comp:item.tipo_compr,nro_comprobante:item.nro_compr,descripcion:item.descripcion,monto:item.monto,caja:item.caja,rubro:item.rubro,fondo:item.fondo,datos_bancarios:item.datos_bcrios,tanda:item.tanda_desc}}
            case 'pdf' : return item => { return { 
                fecha: transformarIso8601(item.fecha), 
                proveedor: item.proveedor, 
                comprobante: `${item.tipo_compr}/${item.nro_compr}`, 
                descripcion: item.descripcion, 
                monto: item.monto, 
                caja: item.caja, 
                rubro: item.rubro,
                fondo:item.fondo,
                tanda:item.tanda_desc,
                datos_bancarios: item.datos_bcrios}
            }
            case 'excel' : return [{label:'Proveedor',value:'proveedor'},
                        {label:'Rubro',value:'rubro'},
                        {label:'Caja',value:'caja'},
                        {label:'Descripción',value:'descripcion'},
                        {label:'Datos bancarios',value:'datos_bcrios'},
                        {label:'Fondo',value:'fondo'},
                        {label:'TC',value:'tipo_compr'},
                        {label:'Comprobante',value:'nro_compr'},
                        {label:'Monto',value:'monto'},{label:'Monto plano',value:'monto_numerico'}]
            case 'arraypdf' : return [{ text: 'Fecha', style: 'tableHeader' }, 
            { text: 'Proveedor', style: 'tableHeader' }, 
            { text: 'Comprobante', style: 'tableHeader' }, 
            { text: 'Descripción', style: 'tableHeader' }, 
            { text: 'Monto', style: 'tableHeader' }, 
            { text: 'Caja', style: 'tableHeader' }, 
            { text: 'Rubro', style: 'tableHeader' },
            { text: 'Fondo', style: 'tableHeader' },
            { text: 'Tanda', style: 'tableHeader' },
            { text: 'Info Banco', style: 'tableHeader' }]
            case 'orientacion' : return 'landscape'
            case 'subtitulo' : return 'landscape'
            case 'clasesbody' : return {col1:'filas-lista-ec ti-reporte-xl',col2:'filas-lista-ec ti-reporte-xxl',col3:'filas-lista-ec ti-reporte-xl',col4:'filas-lista-ec ti-reporte-xxl',col5:'filas-lista-ec ti-reporte-xl text-right'}
            case 'claseshead' : return {col1:'filas-lista-em ti-reporte-xl',col2:'filas-lista-em ti-reporte-xxl',col3:'filas-lista-em ti-reporte-xl',col4:'filas-lista-em ti-reporte-xxl text-center',col5:'filas-lista-em ti-reporte-xl text-right'}
        }
    }else{
        switch(objeto){
            case 'api': return `api/reportes/resumenegresos/${masParametros(parametros)}`
            case 'titulo': return 'Ingresos integrales'
            case 'titulos': return {col1:'Rubro',col2:'Código',col3:'Mes',col4:'Año',col5:'Monto'}
            case 'columnas' : return {col1:'rubro',col2:'codigo_rubro',col3:'mes_largo',col4:'año',col5:'egreso'}
            case 'filtro' : return {campo1:'rubro',campo2:'codigo_rubro',campo3:'egreso_numerico'}
            case 'csv' : return item=>{return {rubro:item.rubro,codigo_rubro:item.codigo_rubro,egreso:item.egreso,periodo:`${item.mes_largo} ${item.año}`}}
            case 'pdf' : return item => { return { 
                rubro: item.rubro, 
                codigo_rubro: item.codigo_rubro, 
                año: item.año,
                mes:item.mes,
                periodo: `${item.mes_largo} ${item.año}`, 
                egreso: item.egreso}
            }
            case 'excel' : return [{label:'Rubro',value:'rubro'},{label:'Código',value:'codigo_rubro'},{label:'Egreso',value:'egreso'},{label:'Mes',value:'mes_largo'},{label:'Año',value:'año'}]
            case 'arraypdf' : return [{ text: 'Rubro', style: 'tableHeader' }, 
            { text: 'Cod. Rubro', style: 'tableHeader' }, 
            { text: 'Período', style: 'tableHeader' }, 
            { text: 'Egreso', style: 'tableHeader' }]
            case 'orientacion' : return 'portrait'
            case 'clasesbody' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
            case 'claseshead' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
        }
    }
}


function bodyTablaEgresosCronologicos (clasesbody){
    return item => {
        return (
                <tr  className="border-bottom-solid" key={uuidv4()}>
                    <td>
                                {transformarIso8601(item.fecha)} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                                <p title='Caja' className='text-small text-white bg-tomato'>{item.caja}</p>
                                <p title='Rubro' className='text-small'>{item.rubro}</p>
                                <p title='Fondo' className='text-small text-grey-dark'>{item.fondo}</p>
                    </td>
                    <td>
                        {item.proveedor} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                        {item.tipo_compr}-{item.nro_compr} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                         {item.descripcion} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td className='text-right'>
                         {item.monto} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>                    
                </tr>
            )
        }
}

function bodyTablaEgresosCronologicosold (clasesbody){
    return item => {
        return (
            <tbody key={uuidv4()}>
                <tr  className="border-bottom-solid">
                    <td>
                        <span className={clasesbody.col1}>
                                {transformarIso8601(item.fecha)} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                        </span>         
                        <span className={clasesbody.col2}>{item.proveedor}</span>
                        <span className={clasesbody.col3}>{item.tipo_compr}-{item.nro_compr}</span>
                        <span className={clasesbody.col4}>{item.descripcion}</span>
                        <span className={clasesbody.col5}>{item.monto}</span>
                    </td>
                </tr>
            </tbody>
            )
        }
}

function masParametros(parametros){

    if (parametros.tipo=='cronologico'){
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/*/${parametros.id_tanda}/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'añofiscal': return `*/*/*/${parametros.id_año_fiscal}/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'año': return `*/*/${parametros.año.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'mesaño': return `*/${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'periodo': return `*/*/*/*/*/${convertirMesAñoAfechaDesde(parametros.fechaDesde)}/${convertirMesAñoAfechaHasta(parametros.fechaHasta)}/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'fecha': return `${parametros.fecha.getDate()}/${parametros.fecha.getMonth()+1}/${parametros.fecha.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
        }
    }else{
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/${parametros.id_tanda}`
            case 'añofiscal': return `*/*/${parametros.id_año_fiscal}/*`
            case 'año': return `*/${parametros.año.getFullYear()}/*/*`
            case 'mesaño': return `${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*`
        }
    }
}

function noNull(valor){
    if (valor){
        return valor
    }else{
        return '*'
    }
}

function convertirMesAñoAfechaDesde(fecha){
    
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha desde es el primer día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

   // const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    

  // return `${mes < 10 ? `0${mes}` : mes}-01-${anio}`
   return `${anio}-${mes < 10 ? `0${mes}` : mes}-01`

}

export function convertirMesAñoAfechaCompleta(fecha) {
    // El propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha se envía en el formato YYYY-MM-DD
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha);

    const dia = fecha_new.getDate();
    const mes = fecha_new.getMonth() + 1;
    const anio = fecha_new.getFullYear();

    return `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`;
}

function convertirMesAñoAfechaHasta(fecha){
        
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha hasta es el último día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

    const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    
   const nueva_fecha =  `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`

    return obtenerFechaUltimoDiaMes(nueva_fecha,'YYYY-MM-DD','YYYY-MM-DD')
}

function Prueba({ref2}){
    const reff = useRef('')

    return <><select title={`dd ${reff.current.value}`} ref={ref2} name="" id="">
        <option value="55">asdfasdf</option>
        <option value="78">gggg</option>
    </select>
    </>
}

function Excel({datos,descripcion}){

    const copia = [agregarFila(datos,descripcion),...datos]
    
   return '' /*<ExcelFile filename={`Egresos cronológicos`} element={
        <span className="cursor-pointer botonNc ml-6" >
            <FontAwesomeIcon className="color-tomato" icon={faFileExcel}/> Exportar a Excel
        </span> 
    }>
        <ExcelSheet data={copia} name="Egresos">
            <ExcelColumn label="Proveedor" value="proveedor"/>
            <ExcelColumn label="Monto" value="monto_numerico"/>
            <ExcelColumn label="Rubro" value="rubro"/>
            <ExcelColumn label="Caja" value="caja"/>
            <ExcelColumn label="Rubro" value="rubro"/>
            <ExcelColumn label="Descripción" value="descripcion"/>
            <ExcelColumn label="Datos bancarios" value="datos_bcrios"/>
            <ExcelColumn label="Fondo" value="fondo"/>
            <ExcelColumn label="TC" value="tipo_compr"/>
            <ExcelColumn label="Comprobante" value="nro_compr"/>
        </ExcelSheet>
</ExcelFile>*/
}

function agregarFila(datos,descripcion){
    return {...datos[0],
            proveedor:descripcion,
            monto_numerico:null,
            rubro:null,
            caja:null,
            rubro:null,
            descripcion:null,
            datos_bcrios:null,
            fondo:null,
            tipo_compr:null,
            nro_compr:null}
}

const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{


    setParametros({...parametros,
                      criterio : nuevoCriterio,
                      id_tanda:tandas[0].id_tanda,
                      id_año_fiscal:null,
                      fechaDesde:new Date(obtenerFechaDiamenosN(365,'DD/MM/YYYY').diamenosn),
                      fechaHasta:new Date(),
                      fecha:new Date(),
                      mesAño:new Date(),
                      año:new Date(),
                    })
}

const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{

    switch(nuevoCriterio){
        case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
        case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
        case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
        case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
        case 'año' : nombreCriterio.current = 'Seleccione el año:';return
        case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
    }
}